<header class="job-header">
  <h5 *ngIf="showCompany" class="job-header__company-name">{{ model.company.name }}</h5>

  <job-status class="job-header__status" [date]="model.createdDate" [filled]="!model.online"></job-status>

  <job-bookmark class="job-header__bookmark" [model]="bookmark" (toggle)="toggleBookmark.emit($event)"></job-bookmark>
</header>

<h3 class="job-title" [class.job-title--with-company]="showCompany">
  <a
    class="job-title__link"
    [routerLink]="['/', JobRoutingEnum.Company, model.company.id, JobRoutingEnum.Job, model.id]"
    [queryParams]="queryParams"
    [queryParamsHandling]="queryParamsHandling"
    fragment="layout-main"
    appEventTracker
    [eventCategory]="trackingData?.eventCategory"
    [eventAction]="trackingData?.eventAction"
    [eventLabel]="trackingData?.eventLabel"
    [eventValue]="trackingData?.eventValue"
    [algoliaTrackingData]="trackingData?.algolia"
    >{{ model.title }}</a
  >
</h3>

<span *ngIf="!model.externalUrl" class="job-quick-apply" i18n>Candidature Simplifiée</span>

<job-tags class="job-tags" [leftAlign]="true" [model]="model" [addStructuredData]="addStructuredData"></job-tags>
